// Focus ring for the story pages' YouTube players (sections/stally-rd-story-page.liquid). The player is a cross-origin
// iframe: with focus inside it Chrome and Edge match neither :focus on the iframe nor :focus-within on its frame, and
// this page gets no focus event, only a window blur (Edge, Oct 21). So the frame carries data-focus-ring while focus is
// in its player. As with :focus-visible, it is decided when focus arrives, from this page's last input (a key, or the
// pointer), and moving the mouse afterwards does not take it away.
// shortcut: keys pressed inside a player never reach this page, so after a mouse move Tab from one player into the next
// gives the next no ring until a key is pressed here; a fix would guess the input from where the pointer last was.
let keyboard = false;
addEventListener('keydown', () => { keyboard = true; }, true);
for (const type of ['pointerdown', 'pointermove']) addEventListener(type, () => { keyboard = false; }, true);

let decidedFor = null;
const mark = () => {
  const active = document.activeElement;
  if (active === decidedFor) return;
  decidedFor = active;
  for (const frame of document.querySelectorAll('.kb-frame-video')) {
    frame.toggleAttribute('data-focus-ring', keyboard && frame.contains(active));
  }
};

// Tab can step from one player straight into the next with no event here, so check while this page is blurred
let timer;
addEventListener('blur', () => { mark(); clearInterval(timer); timer = setInterval(mark, 200); });
addEventListener('focus', () => { clearInterval(timer); mark(); });
